import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/header.png'


const _withScopeId = n => (_pushScopeId("data-v-341dcc13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex w-full mx-auto h-screen bg-gradient-to-t from-bg-primary-dark to-bg-primary text-text-color overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "loading-div"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "helper" }, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "auth-container m-auto flex flex-col gap-y-2 items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header flex justify-center p-2" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo",
      src: _imports_0
    })
  ])
], -1))
const _hoisted_8 = { class: "auth-form w-full" }
const _hoisted_9 = ["onSubmit"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-center text-2xl font-bold my-2 mb-5" }, "Add new article", -1))
const _hoisted_11 = {
  key: 0,
  class: "error text-red-500 text-center font-bold"
}
const _hoisted_12 = {
  key: 1,
  class: "success text-green-500 text-center font-bold"
}
const _hoisted_13 = {
  key: 2,
  class: "error text-red-500 text-center font-bold"
}
const _hoisted_14 = { class: "form-group my-2 relative" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
  })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "form-group my-2" }
const _hoisted_18 = { class: "form-group my-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group my-2" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "w-full bg-link-color text-white px-3 py-2 rounded-lg focus:outline-none",
    type: "submit"
  }, "Add")
], -1))

import {storeUserBlogCallableFunction,crawlSiteCallableFunction} from "../firebase/config"
    import { onAuthStateChanged} from "firebase/auth"
    import { auth } from "../firebase/config";
    import { ref } from "@vue/reactivity"
    import { onMounted } from "@vue/runtime-core"
    import router from "@/router";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePostView',
  setup(__props) {

    const url = ref('')
    const header = ref('')
    const publisher = ref('')
    const error = ref('')
    const success = ref('')
    const isLoading = ref(false)
    

    //check if user logged in
    onMounted(() => {
        const unsub = onAuthStateChanged(auth, (user) => {
            if(!user || !user.emailVerified)
            {
                router.push({ name: "Home"})
            }  
        })

        unsub();
    })

    const createPost = async (event)=>{
        isLoading.value = true
        success.value = ""
        console.log(event,url.value,header.value,publisher.value)

        try{
            await storeUserBlogCallableFunction({
                url:url.value,
                header:header.value,
                publisher:publisher.value
            })
        }
        catch(err){
            error.value = err.message
        }
        

        success.value = "Post added!"
        error.value = ""
        url.value = ""
        header.value = ""
        publisher.value = ""
        isLoading.value = false

    }

    const  crawlSite = async () => {

        try {
            const link = new URL(url.value);
            console.log(link)

            //fetch data
            isLoading.value = true
            const response = await crawlSiteCallableFunction({url:url.value})

            //reset fields
            header.value = ''
            publisher.value = ''
            
            const data = response.data as any            

            if(!data || !data.body)
                throw new Error("Failed to load site's content")
            
            const body = data.body
            
            const el = document.createElement('html') as HTMLElement;
            el.innerHTML = body;
            //console.log(el)
            const siteHeader = el.querySelector("h1")


            if(siteHeader)
                header.value = siteHeader.textContent!

            //detect publisher
            let siteNameDom: HTMLMetaElement | null = el.querySelector("meta[property='og:site_name']");
            let authorMeta: HTMLMetaElement | null = el.querySelector("meta[property='author']");

            if(siteNameDom instanceof HTMLMetaElement)
                publisher.value = siteNameDom.content;

            if(authorMeta instanceof HTMLMetaElement)
                publisher.value = authorMeta.content;

            //detecting publisher for substack
            if(url.value.includes(".substack."))
            {
                const substackPublisher = el.querySelector(".byline-profile-link");

                if(substackPublisher)
                    publisher.value = substackPublisher.textContent!.trim();
            }
            else if(url.value.toLowerCase().includes("medium"))
            {
                const mediumPublisher = el.querySelector(".ci a.bi");

                if(mediumPublisher) 
                    publisher.value = mediumPublisher.textContent!.trim();
            } 
            
            if(!publisher.value.trim())
                publisher.value = link.hostname.split('.')[1];


        } catch (caughtError) {

            if(caughtError.message.includes("Failed to construct"))
                error.value = "Failed to load url"
            else{
                error.value = caughtError.message
            }
        } finally{
            isLoading.value = false
        }
    }   


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(createPost, ["prevent"])
        }, [
          _hoisted_10,
          (_unref(error))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(error)), 1))
            : _createCommentVNode("", true),
          (_unref(success))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(success)), 1))
            : _createCommentVNode("", true),
          (_unref(error))
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(error)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              class: "focus:outline-none rounded-md px-3 py-1 w-11/12",
              type: "text",
              placeholder: "Link",
              required: "",
              autocomplete: "false",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(url) ? (url).value = $event : null))
            }, null, 512), [
              [_vModelText, _unref(url)]
            ]),
            _createElementVNode("div", {
              class: "parse-icon absolute right-0 cursor-pointer",
              onClick: crawlSite
            }, _hoisted_16)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              class: "focus:outline-none rounded-md px-3 py-1 w-full",
              type: "text",
              placeholder: "Title",
              required: "",
              autocomplete: "false",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(header) ? (header).value = $event : null))
            }, null, 512), [
              [_vModelText, _unref(header)]
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              class: "focus:outline-none rounded-md px-3 py-1 w-full",
              type: "text",
              placeholder: "Publisher",
              required: "",
              autocomplete: "false",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(publisher) ? (publisher).value = $event : null))
            }, null, 512), [
              [_vModelText, _unref(publisher)]
            ])
          ]),
          _hoisted_19
        ], 40, _hoisted_9)
      ])
    ])
  ]))
}
}

})